import type { Severity } from '@gostword/engine';

export const SEVERITY_PLURAL: Record<Severity, string> = {
  error: 'Ошибки',
  warning: 'Предупреждения',
  info: 'Советы',
};

/** Короткие подписи для узких экранов. */
export const SEVERITY_SHORT: Record<Severity, string> = {
  error: 'Ошибки',
  warning: 'Предупр.',
  info: 'Советы',
};

export function plural(n: number, forms: readonly [string, string, string]): string {
  const n10 = Math.abs(n) % 10;
  const n100 = Math.abs(n) % 100;
  if (n10 === 1 && n100 !== 11) return forms[0];
  if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return forms[1];
  return forms[2];
}

export const countOf = (n: number, forms: readonly [string, string, string]): string =>
  `${n.toLocaleString('ru-RU')} ${plural(n, forms)}`;

export function fmtDuration(ms: number): string {
  if (ms < 1000) return `${Math.max(1, Math.round(ms))} мс`;
  return `${(ms / 1000).toFixed(1).replace('.', ',')} с`;
}

export function baseName(name: string): string {
  return name.replace(/\.(docx|docm)$/i, '');
}

/** Фрагмент текста вокруг первой подсветки — чтобы было видно, о чём речь. */
export function excerpt(text: string, mark?: [number, number], max = 90): string {
  const clean = (s: string): string => s.replace(/\ufffc/g, '▦').replace(/\s+/g, ' ');
  if (!mark || text.length <= max) return clean(text).trim().slice(0, max) + (text.length > max ? '…' : '');
  const start = Math.max(0, mark[0] - Math.floor(max / 2));
  const end = Math.min(text.length, start + max);
  return (start > 0 ? '…' : '') + clean(text.slice(start, end)).trim() + (end < text.length ? '…' : '');
}
